import { useState, useRef } from 'react';
import cx from 'classnames';

import getPosition from './getPosition';
import getTipContent from './getTipContent';

import {
  StyledTooltip,
  StyledTooltipToggler,
  StyledTooltipMessage
} from './tooltip.style';

type TooltipProps = {
  position?: string;
  message: string;
  isMultiline?: boolean;
  type?: 'default' | 'error' | 'info';
};

const Tooltip = ({
  position = 'top',
  message = '',
  isMultiline = false,
  type = 'default',
  children
}: React.PropsWithChildren<TooltipProps>) => {
  const [isVisible, setIsVisible] = useState(false);
  const node = useRef<HTMLDivElement>(null);
  const tooltip = useRef<HTMLDivElement>(null);

  const showTooltip = (e) => {
    if (!node.current) return;

    const result = getPosition(
      e.currentTarget,
      tooltip.current,
      'top',
      'top',
      {}
    );
    tooltip.current.style.left = result.position.left + 'px';
    tooltip.current.style.top = result.position.top + 'px';
    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  const classNames = cx(`place-${position}`, `type-${type}`, {
    show: isVisible
  });

  const content = getTipContent(message, isMultiline);

  return (
    <StyledTooltip className="custom-tooltip">
      <StyledTooltipToggler
        onMouseOverCapture={showTooltip}
        onMouseOut={hideTooltip}
        ref={node}
      >
        {children}
      </StyledTooltipToggler>
      <StyledTooltipMessage className={classNames} ref={tooltip}>
        {content}
      </StyledTooltipMessage>
    </StyledTooltip>
  );
};

export default Tooltip;
